import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import DesktopPreview from "../components/DesktopPreview";
import SmartphonePreview from "../components/SmartphonePreview";

import { fetchQR } from "../actions/qrs";
import "../styles/QRDetailsView.css";

class QRDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isQRCodeLoaded: false,
    };
    this.handleQRCodeLoad = this.handleQRCodeLoad.bind(this);
    this.downloadQRCode = this.downloadQRCode.bind(this);
  }

  componentDidMount() {
    this.props.fetchQR(this.props.match.params.id);
  }

  handleQRCodeLoad(e) {
    this.setState({
      isQRCodeLoaded: true,
    });
  }

  downloadQRCode(e) {
    const svgData = document.getElementById("qrimage");
    const svgBlob = new Blob([svgData.outerHTML], {
      type: "image/svg+xml;charset=utf-8",
    });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement("a");
    downloadLink.href = svgUrl;
    downloadLink.download = "qrcode.svg";
    downloadLink.click();
    URL.revokeObjectURL(svgUrl);
  }

  returnQrType(type) {
    switch (type) {
      case "pay":
        return "Pago";
      case "free":
        return "Gratis";
      case "test":
        return "Test";
    }
  }

  returnQrMode(mode) {
    switch (mode) {
      case 0:
        return "MTO DIARIO";
      case 1:
        return "OTO DIARIO SIN PIN";
      case 2:
        return "BAQUEIRA";
      case 3:
        return "OTO DIARIO CON PIN";
      case 4:
        return "RESERVA ANTICIPADA";
      case 5:
        return "TIEMPO SIN PIN";
    }
  }

  /*downloadQRCode(e) {

    const { qr } = this.props


    const canvas = document.getElementById("qrimage");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qrimage.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }*/

  render() {
    const { role, type, qr, error, loading } = this.props;
    const { isQRCodeLoaded } = this.state;

    if (error) return <ErrorMessage message={error.message} />;
    if (!qr || loading) return <LoadingProgress />;

    return (
      <div className="qr-details-view">

        {/* Header */}
        <div className="qr-details-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-qrcode"></i>
                <span className="text-vw-dark">QR</span>
                <span className="text-vw-light">{qr.Code}</span>
                <span className={`qr-details-badge ${qr.Enabled ? 'success' : 'danger'}`}>
                  <i className={`fas ${qr.Enabled ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                  {qr.Enabled ? 'Activo' : 'Inactivo'}
                </span>
              </h1>
            </div>
            {role === "ADMIN" && type === "MASTER" && (
              <div className="header-actions">
                <Link to={`/qrs/${qr._id}/edit`} className="qr-details-btn primary">
                  <i className="fas fa-edit"></i><span>Editar</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Info + Time config + QR code */}
        <div className="qr-details-grid">

          {/* General info */}
          <div className="qr-details-card">
            <div className="qr-card-header">
              <i className="fas fa-sliders-h mr-2"></i>Información general
            </div>
            <div className="qr-card-body">
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-hashtag mr-1"></i>Código</span>
                <span className="qr-info-value">{qr.Code}</span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-user mr-1"></i>Cliente</span>
                <span className="qr-info-value">{qr.Customer.Fullname}</span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-map-marker-alt mr-1"></i>Zona</span>
                <span className="qr-info-value">{qr.Zone}</span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-tag mr-1"></i>Tipo</span>
                <span className="qr-info-value">{this.returnQrType(qr.Type)}</span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-cog mr-1"></i>Modo</span>
                <span className="qr-info-value">{this.returnQrMode(qr.Mode)}</span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-link mr-1"></i>URL</span>
                <span className="qr-info-value url-value">{qr.Url}</span>
              </div>
            </div>
          </div>

          {/* Time configuration */}
          <div className="qr-details-card">
            <div className="qr-card-header">
              <i className="fas fa-clock mr-2"></i>Configuración de tiempo
            </div>
            <div className="qr-card-body">
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-hourglass-half mr-1"></i>Tiempo de cortesía</span>
                <span className="qr-info-value">
                  {qr.timeConfig && qr.timeConfig.courtesyTime != null
                    ? `${qr.timeConfig.courtesyTime} min`
                    : <span className="text-muted">—</span>}
                </span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-layer-group mr-1"></i>Máx. franjas por reserva</span>
                <span className="qr-info-value">
                  {qr.timeConfig && qr.timeConfig.maxSlots != null
                    ? qr.timeConfig.maxSlots
                    : <span className="text-muted">—</span>}
                </span>
              </div>
              <div className="qr-info-row">
                <span className="qr-info-label"><i className="fas fa-list-ol mr-1"></i>Franjas de tiempo</span>
                <span className="qr-info-value">
                  {qr.timeConfig && qr.timeConfig.timeSlots && qr.timeConfig.timeSlots.length > 0
                    ? qr.timeConfig.timeSlots.map((slot, i) => (
                        <span key={i} className="badge badge-info mr-1">{slot} min</span>
                      ))
                    : <span className="text-muted">—</span>}
                </span>
              </div>
            </div>
          </div>

          {/* QR code image */}
          <div className="qr-details-card">
            <div className="qr-card-header">
              <i className="fas fa-qrcode mr-2"></i>Visualización QR
            </div>
            <div className="qr-card-body qr-code-body">
              <QRCode
                value={qr.Url}
                id="qrimage"
                renderAs="canvas"
                size={220}
                level={"H"}
                includeMargin={true}
                onLoad={(e) => this.handleQRCodeLoad(e)}
              />
              <button
                className="qr-details-btn secondary mt-3"
                onClick={(e) => this.downloadQRCode(e)}
              >
                <i className="fas fa-download"></i><span>Descargar QR</span>
              </button>
            </div>
          </div>
        </div>

        {/* Header config card + previews */}
        {qr.headerConfig && (
          <div className="qr-preview-row">

            {/* Configuración visual */}
            <div className="qr-details-card">
              <div className="qr-card-header">
                <i className="fas fa-palette mr-2"></i>Configuración visual
              </div>
              <div className="qr-card-body">
                {qr.headerConfig.logoBase64 && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-image mr-1"></i>Logo</span>
                    <div style={{ backgroundColor: qr.headerConfig.primaryColor, borderRadius: '4px', padding: '6px' }}>
                      <img src={qr.headerConfig.logoBase64} alt="Logo" style={{ maxHeight: '40px', maxWidth: '120px' }} />
                    </div>
                  </div>
                )}
                {(qr.headerConfig.primaryColor || qr.headerConfig.secondaryColor) && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-fill-drip mr-1"></i>Gradiente Header</span>
                    <span className="qr-info-value">
                      {qr.headerConfig.primaryColor && <>{qr.headerConfig.primaryColor}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.primaryColor }} /></>}
                      {qr.headerConfig.secondaryColor && <>{' '}{qr.headerConfig.secondaryColor}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.secondaryColor }} /></>}
                    </span>
                  </div>
                )}
                {qr.headerConfig.backgroundColor && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-square mr-1"></i>Color de Fondo</span>
                    <span className="qr-info-value">{qr.headerConfig.backgroundColor}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.backgroundColor }} /></span>
                  </div>
                )}
                {qr.headerConfig.textPrimary && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-font mr-1"></i>Texto Primario</span>
                    <span className="qr-info-value">{qr.headerConfig.textPrimary}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.textPrimary }} /></span>
                  </div>
                )}
                {qr.headerConfig.textSecondary && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-font mr-1"></i>Texto Secundario</span>
                    <span className="qr-info-value">{qr.headerConfig.textSecondary}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.textSecondary }} /></span>
                  </div>
                )}
                {qr.headerConfig.backgroundImage && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-image mr-1"></i>Imagen Fondo Desktop</span>
                    <span className="qr-info-value">
                      <a href={qr.headerConfig.backgroundImage} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{qr.headerConfig.backgroundImage}</a>
                    </span>
                  </div>
                )}
                {qr.headerConfig.backgroundSmartphoneImage && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-mobile-alt mr-1"></i>Imagen Fondo Smartphone</span>
                    <span className="qr-info-value">
                      <a href={qr.headerConfig.backgroundSmartphoneImage} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{qr.headerConfig.backgroundSmartphoneImage}</a>
                    </span>
                  </div>
                )}
                {qr.headerConfig.languageSelectorColor && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-language mr-1"></i>Color Selector Idioma</span>
                    <span className="qr-info-value">{qr.headerConfig.languageSelectorColor}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.languageSelectorColor }} /></span>
                  </div>
                )}
                {qr.headerConfig.buttonColor1 && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-circle mr-1"></i>Color Botón 1</span>
                    <span className="qr-info-value">{qr.headerConfig.buttonColor1}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.buttonColor1 }} /></span>
                  </div>
                )}
                {qr.headerConfig.buttonColor2 && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-circle mr-1"></i>Color Botón 2</span>
                    <span className="qr-info-value">{qr.headerConfig.buttonColor2}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.buttonColor2 }} /></span>
                  </div>
                )}
                {qr.headerConfig.buttonText && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-pen mr-1"></i>Color Texto Botones</span>
                    <span className="qr-info-value">{qr.headerConfig.buttonText}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.buttonText }} /></span>
                  </div>
                )}
                {qr.headerConfig.iconsColor && (
                  <div className="qr-info-row">
                    <span className="qr-info-label"><i className="fas fa-icons mr-1"></i>Color de Iconos</span>
                    <span className="qr-info-value">{qr.headerConfig.iconsColor}<span className="color-swatch" style={{ backgroundColor: qr.headerConfig.iconsColor }} /></span>
                  </div>
                )}
              </div>
            </div>

            {/* Desktop preview */}
            <div className="qr-details-card">
                <div className="qr-card-header">
                  <i className="fas fa-desktop mr-2"></i>Vista Previa Desktop
                </div>
                <div className="qr-card-body">
                  <DesktopPreview
                    primaryColor={qr.headerConfig.primaryColor}
                    secondaryColor={qr.headerConfig.secondaryColor}
                    backgroundColor={qr.headerConfig.backgroundColor}
                    textPrimary={qr.headerConfig.textPrimary}
                    textSecondary={qr.headerConfig.textSecondary}
                    logoBase64={qr.headerConfig.logoBase64}
                    backgroundImage={qr.headerConfig.backgroundImage}
                    languageSelectorColor={qr.headerConfig.languageSelectorColor}
                    buttonColor1={qr.headerConfig.buttonColor1}
                    buttonColor2={qr.headerConfig.buttonColor2}
                    buttonText={qr.headerConfig.buttonText}
                    iconsColor={qr.headerConfig.iconsColor}
                  />
                </div>
            </div>

            {/* Smartphone preview */}
            <div className="qr-details-card">
                <div className="qr-card-header">
                  <i className="fas fa-mobile-alt mr-2"></i>Vista Previa Smartphone
                </div>
                <div className="qr-card-body">
                  <SmartphonePreview
                    primaryColor={qr.headerConfig.primaryColor}
                    secondaryColor={qr.headerConfig.secondaryColor}
                    backgroundColor={qr.headerConfig.backgroundColor}
                    textPrimary={qr.headerConfig.textPrimary}
                    textSecondary={qr.headerConfig.textSecondary}
                    logoBase64={qr.headerConfig.logoBase64}
                    backgroundSmartphoneImage={qr.headerConfig.backgroundSmartphoneImage}
                    backgroundImage={qr.headerConfig.backgroundImage}
                    languageSelectorColor={qr.headerConfig.languageSelectorColor}
                    buttonColor1={qr.headerConfig.buttonColor1}
                    buttonColor2={qr.headerConfig.buttonColor2}
                    buttonText={qr.headerConfig.buttonText}
                    iconsColor={qr.headerConfig.iconsColor}
                  />
                </div>
            </div>

          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  qr: state.qrs.qr,
  loading: state.qrs.loading,
  error: state.qrs.error,
  role: state.auth.role,
  type: state.auth.type,
});

const mapDispatchToProps = (dispatch) => ({
  fetchQR: bindActionCreators(fetchQR, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QRDetailsView);
